import { Modal } from "semantic-ui-react";
import ButtonCustom from "../../../../../../../../components/Button";
import { PUBLIC_URL } from "../../../../../../../App/configs/Constants";
import { Formik } from "formik";
import * as yup from "yup";
import Label from "../../../../../../../../components/Label";
import SizeBox from "../../../../../../../../components/SizeBox";
import InputCustom from "../../../../../../../../components/Input";
import InputPhoneFlag from "../../../../../../../../components/InputPhoneFlag";
import BoxToggleSlider from "../../../../../../../../components/BoxToggleSlider";
import MakeAdminLabelGuide from "../../../../../../../App/views/ModalAddEmployee/MakeAdminLableGuide";
import ModalCenterTemplate from "../../../../../../../App/views/ModalCenterTemplate";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationContext } from "../../../../../../../../locales/Translation";
import { useNavigate, useParams } from "react-router-dom";
import { CURRENT_COMPANY_ID } from "../../../../../../../../configs/Constants";
import { modalCreateStaffSelector } from "../../../../../../selectors/PropertySelector";
import { modalCreatePropertyStaffAction } from "../../../../../../actions/PropertyActions";
import { DIALING_CODE } from "../../../../../../../App/configs/PhonePrefix";
import { userCompanyChooseSelector } from "../../../../../../../User/selectors/UserSelectors";
import { employeePropertyInviteService } from "../../../../../../../User/services/EmployeeServices";
import {
  toastError,
  toastSuccess,
} from "../../../../../../../../components/Toast";
import { getPropertyDetailThunk } from "../../../../../../thunks/PropertyThunks";

const ModalCreateStaff = () => {
  const { id, companyId } = useParams();
  const params = useParams();
  const companyIdDecorated = companyId
    ? companyId
    : localStorage.getItem(CURRENT_COMPANY_ID);
  const modalCreateStaff = useSelector(modalCreateStaffSelector);
  const { translations } = useContext(LocalizationContext);
  const dispatch = useDispatch();
  const userCompanyChoose = useSelector(userCompanyChooseSelector);

  const _onCloseModal = () => {
    dispatch(modalCreatePropertyStaffAction({ open: false }));
  };

  const _onClickSave = async (values: any) => {
    try {
      const payload = { ...values };
      payload.company_id = companyIdDecorated;
      payload.properties = [id];
      payload.job_title = "";

      payload.phone_prefix = DIALING_CODE.filter(
        (country) =>
          country.key.trim().toLowerCase() ===
          values.phone_prefix.trim().toLowerCase()
      )[0].value.replaceAll("+", "");

      await employeePropertyInviteService(payload);
      toastSuccess(translations.employeeAddedSuccessfully);
      await dispatch<any>(getPropertyDetailThunk(id ? id : ""));
      _onCloseModal();
    } catch (e: any) {
      toastError(e?.status?.message);
    }
  };

  return (
    <ModalCenterTemplate
      size={"md"}
      trigger={null}
      onClose={_onCloseModal}
      modalClassName={"modal-general"}
      open={modalCreateStaff.open}
    >
      <Modal.Header>
        {translations.addNewStaff}
        <ButtonCustom onClick={_onCloseModal} className={"modal-close-cta"}>
          <>
            <span>{translations.close}</span>
            <img src={PUBLIC_URL + "/assets/icons/icon-close-grey.svg"} />
          </>
        </ButtonCustom>
      </Modal.Header>
      <Formik
        initialValues={{
          avatar: "",
          user_id: "",
          first_name: "",
          last_name: "",
          email: "",
          phone_number: "",
          phone_prefix: userCompanyChoose?.alpha2_country_code || "SG",
          make_admin: false,
        }}
        validationSchema={yup.object().shape({
          first_name: yup.string().required().label("First Name"),
          email: yup.string().email().required().label("Email"),
          phone_number: yup.number(),
        })}
        onSubmit={_onClickSave}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <>
            <Modal.Content>
              <form className={"form-layout"}>
                <div className={"form-row"}>
                  <InputCustom
                    labelRequired={true}
                    label={"First Name"}
                    value={values.first_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.first_name}
                    error={errors.first_name}
                    name={"first_name"}
                  />
                  <InputCustom
                    label={translations.lastName}
                    value={values.last_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.last_name}
                    error={errors.last_name}
                    name={"last_name"}
                  />
                </div>
                <InputCustom
                  labelRequired
                  label={translations.emailAddress}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.email}
                  error={errors.email}
                  name={"email"}
                />
                <div className={"mb-16px"} />
                <InputPhoneFlag
                  label={translations.mobilePhoneNumber}
                  selectedFlag={values.phone_prefix}
                  onSelectFlag={(code) => setFieldValue("phone_prefix", code)}
                  error={errors.phone_number}
                  touched={touched.phone_number}
                  phoneChange={(value) => setFieldValue("phone_number", value)}
                  phoneValue={values.phone_number}
                />
                <SizeBox height={"12px"} />
                <BoxToggleSlider
                  content={
                    <Label
                      fontSize={"14px"}
                      size={"16px"}
                      label={translations.makeAdmin}
                    />
                  }
                  value={values.make_admin}
                  onChange={() =>
                    setFieldValue("make_admin", !values.make_admin)
                  }
                />
              </form>
            </Modal.Content>
            <Modal.Actions>
              <ButtonCustom height={"47px"} onClick={_onCloseModal}>
                {translations.cancel}
              </ButtonCustom>
              <ButtonCustom
                loading={isSubmitting}
                className={"primary"}
                height={"47px"}
                onClick={handleSubmit}
              >
                {translations.add}
              </ButtonCustom>
            </Modal.Actions>
          </>
        )}
      </Formik>
    </ModalCenterTemplate>
  );
};

export default ModalCreateStaff;
